import gql from 'graphql-tag';

const CLUB_DOCUMENT_DELETE= gql`
mutation clubDocumentDelete($id: ID!) { 
  clubDocumentDelete(id: $id) 
  } 
`;

export default CLUB_DOCUMENT_DELETE;